// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"rg-z","zenCrossSiteLabel":"sg-z","vrsnlCrossSiteLabel":"tg-z"};